import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getNavigationForRole } from "../../config/navigation";
import Icon from "../icon/icon";
import {
  useAuthStore,
  selectLogout,
  selectAuthAdmin,
} from "../../store/useAuth";
import { clearCookie } from "../../config/auth";
import toast from "react-hot-toast";
import "./sidebar.css";

// Sidebar component props interface
export interface SidebarProps {
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isCollapsed, setIsCollapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const logout = useAuthStore(selectLogout);
  const admin = useAuthStore(selectAuthAdmin);

  // Get filtered navigation based on user role
  const navigation = admin ? getNavigationForRole(admin.role, admin) : [];

  const toggleSidebar = (): void => {
    setIsCollapsed(!isCollapsed);
  };

  const handleLogout = (): void => {
    logout();
    clearCookie("authToken");
    toast.success("Вы успешно вышли из системы!");
    navigate("/login");
  };

  return (
    <div className={`sidebar ${isCollapsed ? "sidebar--collapsed" : ""}`}>
      <div className="sidebar__header">
        <div className="sidebar__header-content">
          {!isCollapsed && <h2 className="sidebar__title">Инвестмашина</h2>}
          <button
            className="sidebar__toggle-btn"
            onClick={toggleSidebar}
            title={isCollapsed ? "Развернуть" : "Свернуть"}
          >
            <Icon
              name={isCollapsed ? "right" : "double-left"}
              size="small"
              className="sidebar__toggle-icon"
            />
          </button>
        </div>
      </div>

      <nav className="sidebar__nav">
        {navigation.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar__nav-item ${isActive ? "active" : ""}`}
            >
              <Icon
                name={item.icon}
                size="medium"
                className="sidebar__nav-icon"
              />
              {!isCollapsed && (
                <span className="sidebar__nav-text">{item.title}</span>
              )}
            </Link>
          );
        })}
      </nav>

      <div className="sidebar__footer">
        <button
          className="sidebar__nav-item sidebar__logout"
          onClick={handleLogout}
        >
          <Icon name="logout" size="medium" className="sidebar__nav-icon" />
          {!isCollapsed && <span className="sidebar__nav-text">Выйти</span>}
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
